// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"i5-z","colorTextValue":"j5-z","swatches":"k5-z","collapseLink":"l5-z","isCollapsed":"m5-z","dropdown":"n5-z","disabled":"o5-z"};